var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    values: "95;35",
    keyTimes: "0;1",
    begin: "-0.67s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "-0.67s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    values: "95;35",
    keyTimes: "0;1",
    begin: "-0.33s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "-0.33s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4,
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "1s",
    values: "95;35",
    keyTimes: "0;1",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 0 80 50Z",
    fill: "#0ea0a0",
    transform: "rotate(90 50 50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 0 80 50Z",
    fill: "#0ea0a0"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 50;45 50 50;0 50 50",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L20 50A30 30 0 0 1 80 50Z",
    fill: "#0ea0a0"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0 50 50;-45 50 50;0 50 50",
    keyTimes: "0;0.5;1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.197ef68e6817e92b73e4f1708852e027.svg";
export { ForwardRef as ReactComponent };